var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon37(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 46,
    viewBox: "0 0 37 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3265 30.1925C8.4425 30.1925 0 31.7508 0 37.9841C0 44.2198 8.38979 45.8331 18.3265 45.8331C28.2104 45.8331 36.6529 44.2771 36.6529 38.0414C36.6529 31.8058 28.2654 30.1925 18.3265 30.1925Z",
    fill: "#913BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.3267 24.255C25.0596 24.255 30.4542 18.8581 30.4542 12.1275C30.4542 5.39687 25.0596 0 18.3267 0C11.5961 0 6.19922 5.39687 6.19922 12.1275C6.19922 18.8581 11.5961 24.255 18.3267 24.255Z",
    fill: "#913BFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon37);
export default __webpack_public_path__ + "static/media/icon_37.5a41580f2c108d23c1b9364f7f1aea37.svg";
export { ForwardRef as ReactComponent };